import { ColumnMeta, Updater } from '@tanstack/react-table';

export function getAlignmentClass(
  align: ColumnMeta<unknown, unknown>['align'],
) {
  switch (align) {
    case 'right':
      return 'eye:text-right';
    case 'center':
      return 'eye:text-center';
    default:
      return 'eye:text-left';
  }
}

export function getFlexAlignmentClass(
  align: ColumnMeta<unknown, unknown>['align'],
) {
  switch (align) {
    case 'right':
      return 'eye:justify-end';
    case 'center':
      return 'eye:justify-center';
    default:
      return 'eye:justify-start';
  }
}

export function resolveTableUpdater<T>(updater: Updater<T>, old: T): T {
  return typeof updater === 'function'
    ? (updater as (old: T) => T)(old)
    : updater;
}
